// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1xpuU","col":"styles_col__cd0gD","fulfillmentStatus":"styles_fulfillmentStatus__3jTT9","emailCol":"styles_emailCol__3UC-S"};